import BranchTour from './create-branch-tour'
import CreateProductTour from './create-tour'
import DashboardTour from './dashboard-tour'
import PosTour from './pos-tour'
import PaymentTour from './payment-tour'
import PlansTour from './plans-tour'

export {
    BranchTour,
    CreateProductTour,
    DashboardTour,
    PosTour,
    PaymentTour,
    PlansTour
}


// WEBPACK FOOTER //
// ./src/components/tours/index.js